
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/[articleId]",
      function () {
        return require("private-next-pages/special/[articleId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/[articleId]"])
      });
    }
  